import { SupportedLanguages } from '../../i18n/constants';
import type { LanguageOption } from '../LanguageSelect/types';

export const LANGUAGES_OPTIONS: LanguageOption[] = [
  {
    id: SupportedLanguages.EN,
    name: 'English',
    shortCode: SupportedLanguages.EN,
  },
  {
    id: SupportedLanguages.DE,
    name: 'Deutsch',
    shortCode: SupportedLanguages.DE,
  },
];
